import { useState, useEffect } from 'react'
import { parseString } from 'xml2js'
import { fetchRequest } from '@ocean/api'
import { createProductSheetUrl } from 'modules/simulatorTrainings/common/api/simulatorTrainingService'
import { ParsedProductSheet } from 'modules/simulatorTrainings/common/types/productSheet'

type ParseOut = {
  isLoading: boolean
  result?: ParsedProductSheet
  error?: string
}

const PARSE_ERROR = 'Unable to parse any XML input.'

const useParseProductSheet = (type: string): ParseOut => {
  const [isLoading, setLoading] = useState(true)
  const [result, setResult] = useState<ParsedProductSheet>()
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    setLoading(true)
    fetchRequest(createProductSheetUrl(type), 'GET')
      .then(async (response: Response) => {
        const responseContent = await response.text()
        if (!response.ok) {
          if (response.status === 404) return
          throw new Error(responseContent)
        }
        parseString(
          responseContent,
          { explicitArray: false, normalize: true },
          (error, result: ParsedProductSheet) => {
            const isXML = !!result?.xml
            if (isXML) setResult(result)
            if (error) throw new Error(`${PARSE_ERROR} ${error.message}`)
          }
        )
      })
      .catch((error: Error) => setErrorMessage(error.message))
      .finally(() => setLoading(false))
  }, [type])

  return { isLoading, result, error: errorMessage }
}

export default useParseProductSheet
